import { authApi } from "./index";

export const createBookingReview = async (bookingId, payload) => {
  try {
    const response = await authApi.post(`/Bookings/${bookingId}/review`, payload);
    return response.data.data || response.data;
  } catch (error) {
    console.error(`Failed to submit review for booking ${bookingId}:`, error);
    throw error;
  }
};

export const respondToReview = async (reviewId, payload) => {
  try {
    const response = await authApi.post(`/Reviews/${reviewId}/respond`, payload);
    return response.data.data || response.data;
  } catch (error) {
    console.error(`Failed to submit response to review ${reviewId}:`, error);
    throw error;
  }
};

export const flagReview = async (reviewId, payload) => {
  try {
    const response = await authApi.post(`/Reviews/${reviewId}/flag`, payload);
    return response.data.data || response.data;
  } catch (error) {
    console.error(`Failed to flag review ${reviewId}:`, error);
    throw error;
  }
};
